//import { Spin } from 'antd';
//import Loading from '../assets/images/loading.gif';
import CustomSpin from './Ant/CustomSpin';
//const ImgLoading=<img style={{width:20,height:20}} alt="Loading" src={Loading} />

const DashLoading = () => {
    return (
        // <Spin  indicator={ImgLoading} />
        <CustomSpin size={18}/>
    )
}

export default DashLoading